import script from "./WeeklyScheduler.vue?vue&type=script&setup=true&lang=js"
export * from "./WeeklyScheduler.vue?vue&type=script&setup=true&lang=js"

import "./WeeklyScheduler.vue?vue&type=style&index=0&id=58e27073&lang=css"

const __exports__ = script;

export default __exports__